import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ChartData } from './line-chart';
import _ from 'lodash';
import { ChartDataset } from 'chart.js';
import 'chartjs-adapter-moment';

@Component({
    selector: 'app-line-chart',
    templateUrl: './line-chart.component.html',
    styleUrl: './line-chart.component.scss',
})
export class LineChartComponent {
    @ViewChild('chartCanvas', { static: false }) chartCanvas!: ElementRef;
    @Input() chartType!: 'line' | 'bar';
    @Input() chartConfigurationData!: any;
    @Input() width: number = 1100;
    @Input() height: number = 400;
    @Input() startDate!: number;
    @Input() endDate!: number;
    @Input() interval!: number;
    @Input() xDisplay: boolean = true;
    @Input() xFormat: string = 'MMM DD, YYYY, h:mm A';
    @Input() fillValue!: string;
    @Input() yDisplay: boolean = true;
    @Input() legendDisplay: boolean = true;
    @Input() tooltipDisplay: boolean = true;
    @Input() bgColor: string = '';
    @Input() Unit: string = '';

    labels: string[] = [];
    chartConfigureDataset: any[] = [];
    chartDataset: ChartData[] = [];

    ngOnChanges(): void {
        this.chartInit();
    }

    ngAfterViewInit(): void {
        this.chartInit();
    }

    chartInit() {
        this.chartConfigureDataset = [];
        if (this.chartConfigurationData) {
            this.chartDataset = _.forEach(this.chartConfigurationData.data, (chartData: ChartData) => {
                const values = _.cloneDeep(chartData.values);
                let dataset: ChartDataset = {
                    label: chartData.label,
                    data: values,
                    tension: 0.5,
                    borderColor: this.chartType === 'line' ? chartData.color : (chartData.color ?? undefined),
                    pointBackgroundColor: chartData.color,
                    hoverBackgroundColor: chartData.color,
                    pointBorderColor: 'transparent',
                };

                if (this.fillValue) {
                    dataset.fill = this.fillValue;
                    dataset.pointRadius = 0;
                    dataset.pointHoverRadius = 0;
                    dataset.borderWidth = 1;
                }

                let gradient: any;
                if (this.bgColor === 'gradient' && this.chartCanvas) {
                    const ctx = this.chartCanvas.nativeElement.getContext('2d');

                    // Create gradient
                    gradient = ctx.createLinearGradient(0, 0, 0, 40);
                    gradient.addColorStop(0, chartData.color); // Start (semi-transparent blue)
                    gradient.addColorStop(1, 'rgba(255, 255, 255, 0)'); // End (transparent)
                }

                dataset.backgroundColor = this.bgColor === 'gradient' ? gradient : chartData.color;

                this.chartConfigureDataset.push(dataset);
            });
            this.chartConfigurationData.chartOptions = {
                responsive: true,
                plugins: {
                    tooltip: {
                        enabled: this.tooltipDisplay,
                        mode: 'index',
                        intersect: false,
                    },
                    legend: {
                        display: this.legendDisplay,
                    },
                },
                interaction: {
                    mode: 'index',
                    intersect: false,
                },
                scales: {
                    x: {
                        display: this.xDisplay,
                        type: 'time',
                        time: {
                            unit: this.Unit,
                            tooltipFormat: 'MMM DD, h:mm A',
                            displayFormats: {
                                minute: this.xFormat,
                            },
                        },
                        min: this.startDate,
                        max: this.endDate,
                        ticks: {
                            stepSize: this.interval,
                            autoSkipPadding: 70,
                        },
                        title: {
                            display: true,
                            text: 'Time',
                        },
                        grid: {
                            color: '#C5C5CF',
                        },
                    },
                    y: {
                        display: this.yDisplay,
                        title: {
                            display: true,
                            text: 'Value',
                        },
                        ticks: {
                            autoSkip: true,
                            autoSkipPadding: 10,
                            stepSize: 5,
                        },
                        grid: {
                            color: '#C5C5CF',
                        },
                    },
                },
            };
        }
    }
}
